import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFolderContourSizeS from './IconFolderContour_size_s';

const props: CreateIconArguments = {
  l: IconFolderContourSizeS,
  m: IconFolderContourSizeS,
  s: IconFolderContourSizeS,
  xs: IconFolderContourSizeS,
  name: 'IconFolderContour',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
